import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, Entity, Iso3166TwoDigitCountryCode } from '@onefootprint/request-types/dashboard';
import { Flag } from '@onefootprint/ui';
import { EncryptedCell } from '@/components';
import hasDataIdentifier from '@/utils/has-data-identifier';
import Field from '../../../../../field';
import checkCountryCode from '../utils/check-country-code';
import getInitialCountry from '../utils/get-initial-country';
export type NationalityType = {
  di: DataIdentifier;
  entity: Entity;
};
const Nationality = t0 => {
  const $ = _c(3);
  const {
    di,
    entity
  } = t0;
  const hasLegalStatusCountry = hasDataIdentifier(entity, "id.us_legal_status");
  if (!hasDataIdentifier(entity, "id.nationality") && !hasLegalStatusCountry) {
    return null;
  }
  let t1;
  if ($[0] !== di || $[1] !== entity) {
    t1 = <Field di={di} entity={entity} renderValue={_temp} />;
    $[0] = di;
    $[1] = entity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Nationality;
function _temp(value) {
  if (checkCountryCode(value)) {
    return <div className="flex items-center justify-center gap-3"><Flag code={value as Iso3166TwoDigitCountryCode} /><div className="text-body-2 text-primary" data-dd-privacy="mask">{getInitialCountry(value).label}</div></div>;
  }
  return <EncryptedCell />;
}